module.exports = __webpack_public_path__ + "static/media/logo_define.f06270f1.png";